module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "donate fk__donate"
  }, [_c('div', {
    staticClass: "fk__donate__bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "fk__donate__box"
  }, [_c('h2', {
    staticClass: "fk__heading fk__heading--light fk__donate__heading"
  }, [_vm._v("Make a Donation")]), _vm._v(" "), _c('p', {
    staticClass: "fk__donate__box__copy"
  }, [_vm._v("Famous King is beginning to make an impact and plans to focus full-time creative talent on the task of making God famous. Our goal is to raise over $100k in this first year of operation... we have $10k designated as matching funds already committed to this campaign.")]), _vm._v(" "), _c('p', {
    staticClass: "fk__donate__box__copy"
  }, [_vm._v("Famous King is just getting started. We are excited about our current partners and are eager to see how God's story continues through them. Famous King needs your financial support in order to work on these projects with our partners in a cost effective manner.")]), _vm._v(" "), _c('p', {
    staticClass: "fk__donate__box__copy"
  }, [_vm._v("One such project is a short documentary with the Mustard Seed organization who can be found our project page. The short doc will focus on the importance of getting church leaders into Japan and church multiplication within Japan. Much of the project has already been shot but we still need help funding the post-production phase.")]), _vm._v(" "), _c('p', {
    staticClass: "fk__donate__box__copy"
  }, [_vm._v("Famous King is a fully qualified 501(c)(3) organization and therefore your donation is fully tax deductible.")])]), _vm._v(" "), _c('div', {
    staticClass: "fk__donate__box fk__donate__box--white"
  }, [_c('form', {
    staticClass: "fk__donate__form"
  }, [_c('iframe', {
    staticStyle: {
      "max-width": "500px",
      "min-width": "310px",
      "max-height": "none!important"
    },
    attrs: {
      "src": "https://donorbox.org/embed/new-beginnings-for-famous-king?recurring=true",
      "height": "685px",
      "width": "100%",
      "seamless": "seamless",
      "id": "dbox-form-embed",
      "name": "donorbox",
      "frameborder": "0",
      "scrolling": "no"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f7fc28e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Donate.vue
// module id = 71
// module chunks = 0